import { useQuery } from '@tanstack/react-query';
import { getAttachments } from '../../TimesheetsService';

const useGetTimesheetAttachments = (params, options) =>
    useQuery(['timesheetAttachments', params], () => getAttachments(params), options);

export default useGetTimesheetAttachments;
